module.exports = __webpack_public_path__ + "img/10-25.45c151a6.png";